<template>
  <!--子类专场页面-->
  <tk-container
    :status="status"
    :probeType="3"
    infiniteScroll
    hide-status-bar
    @refresh="refreshInit"
    @scroll="watchScroll"
    :style="{background: bgColor}"
    ref="resetBrand"
    @loadingMore="brandProducts"
  >
    <!--头部-->
    <gradient-header slot="header" :z-index="zIndex" :is-show-back="true"
                     :is-header-color="isHeaderColor" :back-style="isHeaderColor ? false : true" :icon-name="'return'">
      <div slot="center-menu" :style="{color: isHeaderColor ? '#000000' : '#fff'}">
        {{brandSpecial && brandSpecial.category && brandSpecial.category.name ? brandSpecial.category.name : ''}}
      </div>
    </gradient-header>
    <!--背景图渲染-->
    <div class="brand-special-bg" :style="`background-image: url(${bgSrc}) !important`"></div>
    <!--品牌数据渲染-->
    <div class="p-x-12 m-t-15">
      <linear-card
        :width="100" :height="65"
        :linear-bottom-color="'#fff'"
        :linear-top-color="'#CDFFFC'"
        :commodity-arr="brandProductsData"
        :type="'oneBrandSpecial'"
        :title="brandSpecial && brandSpecial.category && brandSpecial.category.name ? brandSpecial.category.name : ''"
        :is-more="false"
      >
        <tk-flex class="p-b-8" wrap v-if="brandProductsData.length">
          <lookCommodity
            class="p-x-12 p-t-8"
            v-for="(s, index) in getPriceProcessing(brandProductsData, judgeTimeRule)"
            :key="index"
            :commodity="s"
            :selling-color="'#999'"
            :selling-bg="'rgba(255, 255, 255, 0)'"
            :is-border="false"
            :is-raised="true"
            :is-rounded="true"
            :bg-color="'#FF9B38'"
          >
          </lookCommodity>
        </tk-flex>
        <empty-tips v-else :height="150" :width="100" :empty-msg="'暂无数据'"></empty-tips>
      </linear-card>
    </div>
  </tk-container>
</template>

<script>
import linearCard from '@/components/linearCard'
import lookCommodity from '@/components/lookCommodity'
import { priceProcessing } from '@/assets/help/tool'
export default {
  components: {
    linearCard,
    lookCommodity
  },
  data () {
    return {
      status: 'loading', // 页面状态
      zIndex: 100, // 头部层
      isHeaderColor: false, // 判断头部颜色切换
      themeBackground: null, // 主题背景图片
      brandSpecial: null, // 品牌专场数据
      brandProductsData: [], // 品牌商品数据
      timeRule: {} // 限时抢购时间规则
    }
  },
  computed: {
    // 背景图src
    bgSrc () {
      if (!this.brandSpecial || (this.brandSpecial && !this.brandSpecial.image)) { return '' }
      return this.brandSpecial.image
    },
    // 背景颜色
    bgColor () {
      if (!this.brandSpecial || (this.brandSpecial && !this.brandSpecial.bgColor)) { return '' }
      return this.brandSpecial.bgColor
    },
    // 判断抢购时间是否有效
    judgeTimeRule () {
      if (!this.timeRule) return false
      let endSum = new Date(this.timeRule.endTime).getTime()
      let nowSum = new Date().getTime()
      return nowSum - endSum < 0
    }
  },
  activated () {
    this.setStatusBar('light')
  },
  mounted () {
    this.getInit()
  },
  beforeRouteLeave (to, from, next) {
    this.setStatusBar('dark')
    next(true)
  },
  methods: {
    /**
     * 页面初始化
     * @date: 2020/4/8
     */
    async getInit () {
      try {
        await this.getThemeBackground() // 获取主题图片
        await this.getLimitedTimeRule() // 获取限时抢购的时间 （只获取1条）
        await this.getBrandSpecial() // 获取品牌专场类别数据
        this.status = false
      } catch (e) {
        this.status = 'error'
        this.$tkGlobal.toast.add('加载数据失败')
      }
    },
    /**
     * 监听页面滚动改变头部背景颜色
     * @date: 2020/3/26
     */
    watchScroll (scrollTop) {
      this.isHeaderColor = scrollTop > 12
      this.setStatusBar(this.isHeaderColor ? 'dark' : 'light')
      this.$forceUpdate()
    },
    /**
     * 页面错误时点击重新加载按钮 @resetInfiniteScroll
     * @date: 2020/3/24
     */
    async refreshInit () {
      this.brandProducts = []
      await this.getInit()
      this.$refs.resetBrand.resetInfiniteScroll()
    },
    /**
     * 限时抢购时间获取
     * @date: 2020/3/20
     */
    async getLimitedTimeRule () {
      let isoStartDate = new Date().toISOString()
      let startTime = await this.$tkAjax.get('https://cloud.dianpei.mokekeji.com/settings/startTime').catch(e => {
        return { data: null }
      })
      let endTime = await this.$tkAjax.get('https://cloud.dianpei.mokekeji.com/settings/endTime').catch(e => {
        return { data: null }
      })
      // 判断时间是否存在
      if (!startTime.data || !endTime.data) {
        this.timeRule = null
        return
      }
      let startSum = new Date(startTime.data).getTime()
      let nowSum = new Date(isoStartDate).getTime()
      if (nowSum <= startSum) {
        this.timeRule = null
        return
      }
      this.timeRule = {
        startTime: startTime.data,
        endTime: endTime.data
      }
    },
    /**
     * 获取主题图片
     * @date: 2020/4/8
     */
    async getThemeBackground () {
      let themeBackground = await this.$tkParse.getList('/classes/themeBackground', {
        params: {
          limit: 1,
          order: '-createdAt',
          where: {
            position: 'brandSpecial'
          }
        }
      })
      if (themeBackground.length) { this.themeBackground = themeBackground[0] } else {
        this.themeBackground = null
      }
    },
    /**
     * 品牌专场类别数据获取
     * @date: 2020/3/20
     */
    async getBrandSpecial () {
      let brandSpecial = await this.$tkParse.getList(`/classes/brandSpecial`, {
        params: {
          limit: 1,
          include: ['category'],
          where: {
            category: this.$route.query.classId
          }
        }
      })
      if (brandSpecial.length) {
        this.brandSpecial = brandSpecial[0]
      } else {
        this.brandSpecial = null
      }
    },
    /**
     * 为你推荐数据获取
     * @date: 2020/3/24
     */
    async brandProducts (page, next) {
      let commodityData = await this.$tkParse.getList(`/classes/commodity`, {
        params: {
          limit: 10,
          skip: page * 10,
          // order: '-sales',
          order: 'weight',
          where: {
            shelvesStatus: 'shelves',
            category: this.$route.query.classId
          }
        }
      })
      this.brandProductsData = [...this.brandProductsData, ...commodityData]
      if (commodityData.length < 10) {
        next('complete')
      } else {
        next('+1')
      }
    },
    /**
     * 工具转换
     * @date: 2020/4/10
     */
    getPriceProcessing (arr, rule) {
      return priceProcessing(arr, rule)
    }
  }
}
</script>

<style scoped lang="scss">
  /*背景图样式*/
  .brand-special-bg {
    width: 100%;
    height: 190px;
    padding-top: 70px;
    background-repeat:  no-repeat;
    background-size: 100% auto;
  }
  ::v-deep .before-trigger {
    color: #fff !important;
  }
</style>
